var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLogs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sand-clock",
    transform: "translate(-72.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26317",
    "data-name": "Group 26317",
    transform: "translate(72.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26316",
    "data-name": "Group 26316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46757",
    "data-name": "Path 46757",
    d: "M81.946,8.52a5.232,5.232,0,0,0,1.086-.955A5.207,5.207,0,0,0,84.166,4.3v-.7a1.759,1.759,0,0,0,1.182-1.653V.587A.589.589,0,0,0,84.757,0H72.939a.589.589,0,0,0-.591.587v1.37A1.759,1.759,0,0,0,73.53,3.609v.7a5.207,5.207,0,0,0,1.135,3.262,5.226,5.226,0,0,0,1.086.955.583.583,0,0,1,0,.959,5.232,5.232,0,0,0-1.086.955A5.207,5.207,0,0,0,73.53,13.7v.7a1.759,1.759,0,0,0-1.182,1.653v1.37a.589.589,0,0,0,.591.587H84.757a.589.589,0,0,0,.591-.587v-1.37a1.759,1.759,0,0,0-1.182-1.653v-.7a5.207,5.207,0,0,0-1.135-3.262,5.226,5.226,0,0,0-1.086-.955A.583.583,0,0,1,81.946,8.52Zm-.684,1.917a4.067,4.067,0,0,1,.841.722,4.048,4.048,0,0,1,.882,2.536v.587H81.75a2.622,2.622,0,0,0-1.175-1.736,2.69,2.69,0,0,1-1.154-1.655.592.592,0,0,0-1.146,0,2.69,2.69,0,0,1-1.154,1.655,2.622,2.622,0,0,0-1.175,1.736H74.712V13.7a4.048,4.048,0,0,1,.882-2.536,4.07,4.07,0,0,1,.84-.722,1.754,1.754,0,0,0,0-2.874,4.068,4.068,0,0,1-.841-.722A4.048,4.048,0,0,1,74.712,4.3V3.717h8.273V4.3A4.048,4.048,0,0,1,82.1,6.841a4.07,4.07,0,0,1-.84.722A1.754,1.754,0,0,0,81.262,10.437Z",
    transform: "translate(-72.348)",
    fill: "#00a1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26319",
    "data-name": "Group 26319",
    transform: "translate(76.208 4.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26318",
    "data-name": "Group 26318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46758",
    "data-name": "Path 46758",
    d: "M186.106,139.13h-4.1a.587.587,0,0,0-.512.879,2.961,2.961,0,0,0,1.042,1.055,1.943,1.943,0,0,1,.947,1.457.59.59,0,0,0,.573.443h0a.59.59,0,0,0,.572-.443,1.941,1.941,0,0,1,.945-1.456,2.962,2.962,0,0,0,1.042-1.055A.587.587,0,0,0,186.106,139.13Z",
    transform: "translate(-181.418 -139.13)",
    fill: "#00a1af"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLogs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_logs.84d748d718042c32be0ea8155571427b.svg";